import { Operator } from '../types/sharedTypeImpl.ts';
import { trpc } from '../utils/trpc/trpc.ts';


interface Props {
    className?: string;
    style?: React.CSSProperties;
    operatorInitials?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    onChange?: (operatorInitials: string) => void;
}

export function OperatorSelect({
    className,
    style,
    operatorInitials,
    required,
    disabled,
    readOnly,
    onChange,
}: Props) {

    const { data: operators } = trpc.operators.getAll.useQuery(undefined, {
        select: (operators) => [...operators].sort((a, b) => a.initials.localeCompare(b.initials))
    });


    const usingUnlistedOperator = operatorInitials && !operators?.find(
        (it) => it.initials.toUpperCase() === operatorInitials.toUpperCase()//Back in the day, people didn't use consistent casing
    );
    const options = [
        ...operators?.filter(it => it.isActive || it.initials === operatorInitials) ?? [],
        ...(usingUnlistedOperator ? [{ initials: operatorInitials.toUpperCase() } as Operator] : [])
    ];


    return (
        <select
            className={className}
            style={{ ...style, pointerEvents: readOnly ? 'none' : 'auto' }}
            disabled={disabled ?? false}
            required={required}
            value={operatorInitials ?? ''}
            onChange={(event) => onChange?.(event.target.value)}
        >
            <option value='' disabled hidden />
            {options?.map((it) => (
                <option key={it.initials} value={it.initials}>
                    {it.initials}{it.fullName && ` - ${it.fullName}`}
                </option>
            ))}
        </select>
    )
}
